import { useEffect, useRef, useState } from 'react';
import type { CatalogCategoryKindType } from '@econtractor/types';
import { useAuth } from 'context/AuthContext';
import { isSameIdSet } from 'utils/helpers/list/isSameIdSet';
import { loadCatalogCategoryIds, saveCatalogCategoryIds } from './catalogCategoryFilterStorage';

const useCatalogCategoryFilter = (kind: CatalogCategoryKindType) => {
    const { auth } = useAuth();
    const userId = Number(auth?.user?.ID || 0);
    const hydratedUserId = useRef(userId);
    const skipNextSave = useRef(true);
    const [filterCategoryIds, setFilterCategoryIds] = useState<number[]>(() =>
        loadCatalogCategoryIds(userId, kind),
    );

    useEffect(() => {
        if (!userId || hydratedUserId.current === userId) return;
        hydratedUserId.current = userId;
        skipNextSave.current = true;
        const loaded = loadCatalogCategoryIds(userId, kind);
        setFilterCategoryIds((prev) => (isSameIdSet(prev, loaded) ? prev : loaded));
    }, [userId, kind]);

    useEffect(() => {
        if (!userId) return;
        if (skipNextSave.current) {
            skipNextSave.current = false;
            return;
        }
        saveCatalogCategoryIds(userId, kind, filterCategoryIds);
    }, [filterCategoryIds, kind, userId]);

    return { filterCategoryIds, setFilterCategoryIds };
};

export default useCatalogCategoryFilter;
